import Countdown from 'react-countdown'

const getTimeToMidnightFromNowInMS = () => {
  const epochMs = 1643148000000
  const now = Date.now()
  const msInDay = 86400000
  const index = Math.floor((now - epochMs) / msInDay)
  return epochMs + (index + 1) * msInDay
}

export const NextWirdCountdown = () => {
  return (
    <div className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
      <div className="col-span-2 ">الوِرد القادم</div>
      <div className="col-span-2 ">
        <Countdown daysInHours={true} date={getTimeToMidnightFromNowInMS()} />
      </div>
    </div>
  )
}
